import script from "./Parceria.vue?vue&type=script&setup=true&lang=js"
export * from "./Parceria.vue?vue&type=script&setup=true&lang=js"

import "./Parceria.vue?vue&type=style&index=0&id=026b33ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026b33ce"]])

export default __exports__